import GridIMG from "./GridIMG";
import NavbarPC from "./NavbarPC"; // 네비게이션 바 추가

const LandingHomePC = () => {
  const basePath = `${process.env.PUBLIC_URL}/image/pc`;
  const imagePaths = Array.from(
    { length: 13 },
    (_, i) => `${basePath}/20250204_${i + 1}.png`
  );

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="landing-container">
      <NavbarPC /> {/* 네비게이션 바 추가 */}
      <div className="image-container">
        {imagePaths.map((src, index) => (
          <div key={index} className="image-wrapper">
            <img
              id={`image-${index + 1}`}
              src={src}
              alt={`Image ${index + 1}`}
            />
            {index === 2 && <GridIMG />}
            {/* 두 번째 이미지 아래에 GridIMG 추가 */}
          </div>
        ))}
      </div>
      {/* <img
        src={`${process.env.PUBLIC_URL}/image/up.png`}
        alt="Scroll to Top"
        className="scroll-to-top"
        onClick={scrollToTop}
      /> */}
      <style jsx>{`
        .landing-container {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .image-container {
          margin-top: 120px; /* 네비게이션 바 높이 고려 */
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
        }

        img {
          width: 100vw;
          max-width: 100%;
          height: auto;
        }
        .scroll-to-top {
          width: 50px;
          height: 50px;
          position: fixed;
          bottom: 100px;
          right: 20px;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default LandingHomePC;
